// v src/components/NotFound.js
import React from 'react';
import { Container, Col, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from '../../../src/assets/styles/HomePage.module.scss';

import Header from '../Header';
import Footer from '../Footer';
const NotFound = () => {

    return (
        <div>
            <Header headerAbsolute={true} />
            <div className={styles.notFoundPage}>
                <Container fluid >
                    <Row className="justify-content-center text-center">
                        <Col md={6} className="p-4">
                            <h1>404 - Stránka nenalezena</h1>
                            <p className='lead'>Omlouváme se, stránka, kterou hledáte, neexistuje nebo byla přesunuta.</p>

                            <p>Možná jste zadali špatnou adresu, nebo byla stránka odstraněna.</p>
                            <Button as={Link} to="/" size="lg" className='btn-albert-dark'>Zpět na hlavní stránku</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Footer/>
        </div>
    );
};

export default NotFound;
